const { connect } = require('react-redux');
const { context } = require('../app-context');
const UserSearchFilterDialog = require('components/UserSearchFilterDialog');

const selectors = context.selectors.all;
const actions = context.actions;
const redux = context.redux.hooks;

module.exports = connect(
    (state) => ({
        interests: selectors.getInterests(state),
        majors: selectors.getMajorsList_forCurrentUser(state),
        incomingClassList: selectors.getIncomingClassList_forCurrentUser(state),
        graduatingClassList: selectors.getGraduatingClassList_forCurrentUser(state),
        isParent: selectors.isParentPermission(state),
        currentUserPermissions: selectors.getCurrentUserRolePermissions(state),
        currentUserRole: selectors.getCurrentUserRole(state),
        discoverSortType: selectors.getDiscoverSortType(state),
        departments: selectors.getDepartmentsList_forProfileEditPage(state),
        yearsHiredList: selectors.getAllYearsHired(state),
        officesList: selectors.getAllOffices(state),
        isCompany: selectors.getSchoolIsCompany(state),
        isCommunity: selectors.getSchoolIsCommunity(state),
        isSchoolOnline: selectors.getSchoolIsOnline(state),
        allRoles: selectors.getRoles(state),
        discoverSearchFilter: selectors.getDiscoverSearchFilter(state),
        badges: selectors.getAllBadges(state),
        roleGroupFilter: selectors.getRoleGroupFilter(state, 'discover'),
        availableRoleGroups: selectors.getSchoolUsedRoleGroups(state),
        housingList: selectors.getHousingList_bySchoolId(state, selectors.getCurrentSchoolId(state))
    }),
    {
        resetSearch: (sortType) => (dispatch) => {

            const state = redux.getState();
            const { discoverMatching: debug } = selectors.getDebug(state);

            dispatch(actions.app.setDiscoverSearchFilter({ filter: {} }));
            dispatch(actions.app.setRoleGroupFilter({ discover: 'all' }));

            return dispatch(actions.dataFetching.fetchDiscoverSearchResults.firstPage({
                allByMatches: true,
                sortType,
                debugMatching: !!debug
            }));
        }
    }
)(UserSearchFilterDialog);
